import { useContext, useEffect, useState } from "react";

import HefringLogo from "assets/hefring-wordmark.svg";
import { Color } from "utils/theme";
import { AppContext } from "contexts/app-context";

export const SplashScreen = () => {
  const { isClientConnected } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (isClientConnected) return;

    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 2_000);

    return () => clearTimeout(loadingTimer);
  }, []);

  // Hide splash screen when not loading or app is initialized
  if (!isLoading || isClientConnected) return null;

  return (
    <div
      className="absolute z-50 h-screen w-full bg-primary-950 flex justify-center items-center p-10"
      style={{ background: Color.Primary[900] }}
    >
      <img
        className="animate-fadeUp h-20 lg:h-32"
        src={HefringLogo}
        alt="Hefring Logo"
        height={"100%"}
        width={"100%"}
      />
    </div>
  );
};
